import styled, { css } from 'styled-components'

export const StyledMessageTemplateItem = styled.div`
    ${({ theme, color, isSmallSize }) => css`
        display: grid;
        align-items: center;
        grid-template-columns: auto 1fr;
        width: 90%;
        padding: ${theme.spacing * 3}px;
        gap: ${theme.spacing}px;
        border-radius: 16px 16px 0px 16px;
        border: 1px solid ${theme.palette.gray.light};
        background: ${theme.palette.gray.dark};
        cursor: pointer;
        &:hover {
            border-color: ${color};
            & svg {
                & path {
                    fill: ${color};
                }
            }
        }
        ${isSmallSize &&
        css`
            width: 90% !important;
            padding: ${theme.spacing * 2}px;

            & svg {
                width: 16px;
                height: 20px;
            }
        `}
        ${theme.mediaQueries.mUp} {
            width: 430px;
        }
    `}
`

export const StyledMessageTemplateText = styled.p`
    ${({ theme, isBold, isSmallSize }) => css`
        font-family: ${isBold ? 'Gilroy-Bold' : 'Gilroy-Regular'};
        font-size: 16px;
        color: ${theme.palette.white};
        margin: 0 !important;
        text-align: start;
        white-space: pre-wrap;
        word-break: break-word;
        ${isSmallSize &&
        css`
            font-size: 14px;
        `}
    `}
`

export const StyledMessageItem = styled.div`
    ${({ theme, isMine, color, isSmallSize }) => css`
        display: flex;
        align-items: center;
        gap: ${theme.spacing}px;
        max-width: 600px;
        padding: ${theme.spacing * 3}px;
        align-self: ${isMine ? 'flex-end' : 'flex-start'};
        border-radius: ${isMine ? '16px 16px 0px 16px' : '16px 16px 16px 0px'};
        background: ${isMine ? theme.palette.gray.main : color};
        ${isSmallSize &&
        css`
            max-width: 90% !important;
            padding: ${theme.spacing * 2}px;
        `}
    `}
`
export const StyledLoadingMessageItem = styled(StyledMessageItem)`
    ${({ theme, isSmallSize }) => css`
        width: fit-content;
        ${isSmallSize &&
        css`
            width: fit-content !important;
        `}
        ${theme.mediaQueries.lUp} {
            width: fit-content;
        }
    `}
`

export const StyledAlertIcon = styled.div`
    display: flex;
    align-items: center;
    & svg {
        width: 26px;
        height: 26px;
    }
`

export const StyledCode = styled.div`
    ${({ theme, isCode }) => css`
        ${isCode &&
        css`
            position: relative;
            border: 1px solid ${theme.palette.gray.light};
            background: rgba(182, 191, 201, 0.4);
            border-radius: 16px;
            margin-bottom: ${theme.spacing / 2}px;
            padding: ${theme.spacing * 1.5}px;
        `}
    `}
`

export const StyledCopyButton = styled.div`
    ${() => css`
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
        & svg {
            width: 18px;
            height: 20px;
        }
    `}
`

export const StyledContainerPlayIcon = styled.div`
    ${() => css`
        display: flex;
        justify-content: end;
        margin-top: 5px;
        cursor: pointer;
    `}
`
